/**
 * Publishes the product details column's height as `--details-height`.
 *
 * The column should hold its bottom edge against the bottom of the viewport so the
 * last block stays in view while the taller media column scrolls past. The natural
 * way to say that is `position: sticky; bottom: 0`, but the bottom offset does not
 * engage for grid or flex items and the column is a grid item, so the same result is
 * expressed as a top offset of one viewport minus the column's own height. CSS has no
 * way to reference an element's own height, hence this.
 *
 * Without this script the offset falls back to plain top-sticking, so the column still
 * sticks -- it just pins its top rather than its bottom.
 */

const SELECTOR = '.product-details.sticky-content--desktop';

/**
 * @param {Element} element
 */
function publishHeight(element) {
  if (!(element instanceof HTMLElement)) return;

  element.style.setProperty('--details-height', `${Math.round(element.getBoundingClientRect().height)}px`);
}

const resizeObserver = new ResizeObserver((entries) => {
  for (const entry of entries) publishHeight(entry.target);
});

function observeDetails() {
  for (const element of document.querySelectorAll(SELECTOR)) {
    publishHeight(element);
    resizeObserver.observe(element);
  }
}

observeDetails();

// The theme editor swaps the section wholesale, which leaves the old element observed
// and the new one unmeasured.
document.addEventListener('shopify:section:load', observeDetails);
